const EMPLOYMENT_STATUSES = [
  { name: '正社員', value: 1 },
  { name: '契約社員', value: 2 },
  { name: '派遣', value: 3 },
  { name: 'アルバイト', value: 4 }
];

export default EMPLOYMENT_STATUSES;
